export default __webpack_public_path__ + "static/media/Infrastructure-Maintenance.f08f1000.jpg";